import React from "react";

interface IModalProps {}

export const LoginEsiaNoEmailForm: React.FC<IModalProps> = () => {
  return (
    <div style={{ width: "500px", textAlign: "center" }}>
      В профиле на Госуслугах не заполнен адрес электронной почты, который
      необходим для работы в системе. Пожалуйста, заполните адрес электронной
      почты на портале Госуслуги и попробуйте снова.
    </div>
  );
};
